import { render, staticRenderFns } from "./sortContent.vue?vue&type=template&id=a0766754&"
import script from "./sortContent.vue?vue&type=script&lang=js&"
export * from "./sortContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports